import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {SessionModel} from '@/sdk';
import {AutentictionApi} from '@/sdk/api-services';
import {RolesService} from '@/views/shared/services';
import {Component} from 'vue-property-decorator';
import {isNavigationFailure, NavigationFailureType} from 'vue-router';

@Component
export default class SigninComponent extends VueWrapper {
    // public orgCode: String | null = null;
    public loginId: String | null = null;
    public password: String | null = null;

    public show1: boolean = false;

    public authenticationApi: AutentictionApi = new AutentictionApi();

    public created() {
        const loginIdQuery = this.$route.query.loginId as string | undefined;
        if (loginIdQuery) {
            this.loginId = loginIdQuery;
        }
    }

    public localeChange() {
        localStorage.setItem('locale', this.$i18n.locale);
    }

    public goToSignupPage() {
        console.log('go to Signup page clicked');
        this.$router.push({name: 'signup'});
    }

    public goToForgotPasswordPage() {
        this.$router.push({
            name: 'forgotPassword',
            query: {
                loginId: this.loginId as string,
            },
        });
    }

    public goToLandingPage() {
        console.log('go to Home page clicked');

        this.LoaderSrv.showFullScreenLoader();
        this.authenticationApi
            .Login({
                loginId: this.loginId,
                password: this.password,
                RememberMe: true,
            })
            .subscribe(
                res => {
                    if (res.Data) {
                        const s = new SessionModel({...res.Data, selectedAccountId: res.Data.accountId});
                        this.UserSessionSrv._session.next(s);
                        this.UserSessionSrv.save();

                        // if (this.UserSessionSrv.Session?.roleId) {
                        //     new RolesService().getRolePermissions(this.UserSessionSrv.Session.roleId);
                        // }
                        if (this.UserSessionSrv.Session?.userId) {
                            new RolesService().getUserRolePermissions(this.UserSessionSrv.Session?.userId);
                            new RolesService().getPaymentStatus();
                        }

                        this.$router.push({name: 'sites-list'}).catch(error => {
                            if (
                                isNavigationFailure(error, NavigationFailureType.redirected) ||
                                isNavigationFailure(error, NavigationFailureType.duplicated) ||
                                isNavigationFailure(error, NavigationFailureType.cancelled) ||
                                isNavigationFailure(error, NavigationFailureType.aborted)
                            ) {
                                return;
                            }

                            throw error;
                        });
                    }
                    console.log(res);
                },
                err => {
                    console.log('err', err);
                    const errorCode = err?.error?.code;
                    const details = err?.error?.details;
                    if (errorCode === 'PHONE_NOT_VERIFIED') {
                        const userId = details?.userId as string | undefined;
                        const phoneNumber = details?.phoneNumber as string | undefined;
                        if (userId) {
                            this.AlertSrv.show('info', 'Please verify your mobile number.').then(() => {
                                this.$router.push({
                                    name: 'phoneVerification',
                                    query: {
                                        userId,
                                        phone: phoneNumber,
                                        loginId: this.loginId as string,
                                    },
                                });
                            });
                            return;
                        }
                    }
                    this.AlertSrv.show('error', '$t.Common.Login.Error');
                }
            )
            .add(() => {
                this.LoaderSrv.hideFullScreenLoader();
            });
    }
}
